import { toast, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import { API_URL } from '../Utils/url'
// import { RootColorTheme } from "../css/rootColorTheme";


const MySwal = withReactContent(Swal);

const startLoader = () => {
  Swal.fire({
    title: "Loading...",
    text: "Please wait...",
    background: localStorage.getItem("ThemeMode") === "dark" ? '#1a1a1a' : 'white',
    color: localStorage.getItem("ThemeMode") === "dark" ? 'white' : 'black',
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
};

const stopLoader = () => {
  Swal.close();
};

const getData = async (route, queryParamsArg, token, isToastNeeded = true, module = '', ignore401 = false) => {

  try {
    // startLoader();
    const URL_ROUTE = `${API_URL}${route}`;
    const headers = {
      ...(token && { Authorization: `${token}` }),
      "Content-Type": "application/json",
    };

    let url = URL_ROUTE;
    if (queryParamsArg) {
      const queryParams = new URLSearchParams(queryParamsArg).toString();
      url += `?${queryParams}`;
    }

    const options = {
      method: 'GET',
      headers: headers,
    };

    const response = await fetch(url, options);
    let responseData;
    try {
      responseData = await response.json();
    } catch (err) {
      responseData = { error: true, message: 'Server error or invalid response' };
    }
    if ((((response.status === 401 || response.status === 403) || response.status === 403) || response.status === 403) && !ignore401) {
      await MySwal.fire({
        title: "Session Expired",
        text: 'Session Expired. Kindly, Login Again',
        icon: "warning",
        showCancelButton: false,
        // confirmButtonColor: RootColorTheme,
        confirmButtonText: "OK",
      });
      sessionStorage.clear();
      localStorage.clear();
      window.location.replace('/');
    }
    if (response.status === 200) {
      console.log(responseData.message || 'Success');
    }
    if (isToastNeeded && response.status === 200) {
      toast.success(responseData.message, {
        position: 'top-right',
        transition: Zoom,
      });
    }
    if (isToastNeeded) {
      if (response?.status === 404) {
        toast.error(responseData?.message || "An error occurred", {
          position: 'top-right',
          transition: Zoom,
        });
      }
    }
    // stopLoader();
    return responseData;
  } catch (error) {
    console.error(error);
    if (isToastNeeded) {
      toast.error(error.message || "An error occurred", {
        position: 'top-right',
        transition: Zoom,
      });
    }
    stopLoader()
    throw error;
  }
};

const postData = async (route, data, token, isLoaderRequired = true, ignore401 = false) => {
  try {
    if (isLoaderRequired) startLoader();
    const URL_ROUTE = `${API_URL}${route}`;

    const headers = {
      ...(token && { Authorization: `${token}` }),
      "Content-Type": "application/json",
    };

    const response = await fetch(URL_ROUTE, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch");
    }
    const responseData = await response.json();
    if ((((response.status === 401 || response.status === 403) || response.status === 403) || response.status === 403) && !ignore401) {
      sessionStorage.clear();
      localStorage.clear();
      window.location.replace('/');
    }
    if (response.status === 200) {
      toast.success(responseData.message, {
        position: 'top-right',
        transition: Zoom,
      });
    }
    if (isLoaderRequired) stopLoader();
    return responseData;
  } catch (error) {
    if (error.message === '401 Unauthorized' && !ignore401) {
       // already handled above usually
    }
    toast.error(error.message || "An error occurred", {
      position: 'top-right',
      transition: Zoom,
    });
    stopLoader();
    throw error;
  }
};

const postFileUpload = async (route, data, token, ignore401 = false) => {
  try {
    startLoader();
    const URL_ROUTE = `${API_URL}${route}`;
    const headers = {
      ...(token && { Authorization: `${token}` }),
    };

    const response = await fetch(URL_ROUTE, {
      method: "POST",
      headers: headers,
      body: data,
    });
    if (!response.ok) {
      if ((((response.status === 401 || response.status === 403) || response.status === 403) || response.status === 403) && !ignore401) {
        sessionStorage.clear();
        localStorage.clear();
        window.location.replace('/');
      }
    }
    let responseData;
    try {
      responseData = await response.json();
    } catch (err) {
      responseData = { error: true, message: 'Server error or invalid response' };
    }
    if (!response.ok) {
      throw new Error(responseData.message || "Failed to fetch");
    }
    if (((response.status === 401 || response.status === 403) || response.status === 403)) {
      sessionStorage.clear();
      localStorage.clear();
      window.location.replace('/');
    }
    if (response.status === 200) {
      toast.success(responseData.message, {
        position: 'top-right',
        transition: Zoom,
      });
    }
    stopLoader();
    return responseData;
  } catch (error) {
    toast.error(error.message || "An error occurred", {
      position: 'top-right',
      transition: Zoom,
    });
    console.error(error);
    stopLoader();
    throw error;
  }
};

const FileUpload = async (route, data) => {
  try {
    startLoader();
    const URL_ROUTE = `${API_URL}${route}`;
    const response = await fetch(URL_ROUTE, {
      method: "POST",
      body: data,
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch");
    }
    const responseData = await response.json();
    if (((response.status === 401 || response.status === 403) || response.status === 403)) {
      sessionStorage.clear();
      localStorage.clear();
      window.location.replace('/');
    }
    if (response.status === 200) {
      toast.success(responseData.message, {
        position: 'top-right',
        transition: Zoom,
      });
    }
    stopLoader();
    return responseData;
  } catch (error) {
    console.error(error);
    toast.error(error.message || "An error occurred", {
      position: 'top-right',
      transition: Zoom,
    });
    stopLoader();
    throw error;
  }
};

const patchData = async (route, data, token) => {
  try {
    startLoader();
    const URL_ROUTE = `${API_URL}${route}`;
    const headers = {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    };

    const response = await fetch(URL_ROUTE, {
      method: "PATCH",
      headers: headers,
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to update");
    }
    const responseData = await response.json();
    if (((response.status === 401 || response.status === 403) || response.status === 403)) {
      sessionStorage.clear();
      localStorage.clear();
      window.location.replace('/');
    }
    if (response.status === 200) {
      toast.success(responseData.message, {
        position: 'top-right',
        transition: Zoom,
      });
    }
    stopLoader();
    return responseData;
  } catch (error) {
    console.error(error);
    toast.error(error.message || "An error occurred", {
      position: 'top-right',
      transition: Zoom,
    });
    stopLoader();
    throw error;
  }
};

const putData = async (route, data, token) => {
  try {
    startLoader();
    const URL_ROUTE = `${API_URL}${route}`;
    const isFormData = data instanceof FormData;
    const headers = {
      Authorization: `${token}`,
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
    };

    const response = await fetch(URL_ROUTE, {
      method: "PUT",
      headers: headers,
      body: isFormData ? data : JSON.stringify(data),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to update");
    }
    let responseData;
    try {
      responseData = await response.json();
    } catch (err) {
      responseData = { error: true, message: 'Server error or invalid response' };
    }
    if (((response.status === 401 || response.status === 403) || response.status === 403)) {
      sessionStorage.clear();
      localStorage.clear();
      window.location.replace('/');
    }
    if (response.status === 200) {
      toast.success(responseData.message, {
        position: 'top-right',
        transition: Zoom,
      });
    }
    stopLoader();
    return responseData;
  } catch (error) {
    console.error(error);
    toast.error(error.message || "An error occurred", {
      position: 'top-right',
      transition: Zoom,
    });
    stopLoader();
    throw error;
  }
};

const deleteData = async (route, token) => {
  try {
    startLoader();
    const URL_ROUTE = `${API_URL}${route}`;
    const headers = {
      Authorization: `${token}`,
    };

    const response = await fetch(URL_ROUTE, {
      method: "DELETE",
      headers: headers,
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to delete");
    }
    let responseData = {};
    const text = await response.text();
    if (text) {
      responseData = JSON.parse(text);
    }
    if (((response.status === 401 || response.status === 403) || response.status === 403)) {
      sessionStorage.clear();
      localStorage.clear();
      window.location.replace('/');
    }
    if (response.status === 200) {
      toast.success(responseData.message, {
        position: 'top-right',
        transition: Zoom,
      });
    }
    stopLoader();
    return responseData;
  } catch (error) {
    console.error(error);
    toast.error(error.message || "An error occurred", {
      position: 'top-right',
      transition: Zoom,
    });
    stopLoader();
    throw error;
  }
};

const deleteWithQuery = async (route, queryParamsArg = null, token, isToastNeeded = true) => {
  try {
    const URL_ROUTE = `${API_URL}${route}`;
    const headers = {
      ...(token && { Authorization: `${token}` }),
      "Content-Type": "application/json",
    };

    let url = URL_ROUTE;
    if (queryParamsArg) {
      const queryParams = new URLSearchParams(queryParamsArg).toString();
      url += `?${queryParams}`;
    }

    const options = {
      method: 'DELETE',
      headers,
    };

    const response = await fetch(url, options);
    const responseData = await response.json();

    if (((response.status === 401 || response.status === 403) || response.status === 403)) {
      await MySwal.fire({
        title: "Session Expired",
        text: 'Session Expired. Kindly, Login Again',
        icon: "warning",
        // confirmButtonColor: RootColorTheme,
        confirmButtonText: "OK",
      });
      sessionStorage.clear();
      localStorage.clear();
      window.location.replace('/');
    }

    if (isToastNeeded && response.status === 200) {
      toast.success(responseData.message, {
        position: 'top-right',
        transition: Zoom,
      });
    } else if (isToastNeeded && response.status === 404) {
      toast.error(responseData?.message || "An error occurred", {
        position: 'top-right',
        transition: Zoom,
      });
    }

    return responseData;
  } catch (error) {
    console.error(error);
    if (isToastNeeded) {
      toast.error(error.message || "An error occurred", {
        position: 'top-right',
        transition: Zoom,
      });
    }
    throw error;
  }
};

export {
  getData, postData, patchData,
  deleteData, FileUpload, postFileUpload,
  putData, deleteWithQuery
};
